(function () {
  var COHORT_KEY = 'haro_price_cohort';
  var META_VALUE = 'meta';
  var COOKIE_MAX_AGE = 60 * 60 * 24 * 90;
  var META_SOURCES = ['meta', 'facebook', 'instagram', 'fb', 'ig'];
  var PRODUCT_PATH_MAP = {
    '/products/haro-clear': '/products/haro-clear-meta',
    '/products/haro-clear-starter-kit': '/products/meta-haro-clear-starter-kit-90-day-eye-health-supply',
    '/products/haro-clear-refill-pouch-45-day': '/products/meta-haro-clear-refill-pouch-45-day-supply-eye-health-supplement-90-capsules',
    '/products/haro-clear-refill-pouch-90-day-supply-sands': '/products/haro-clear-refill-pouch-90-day-supply-eye-health-supplement-180-capsules-meta'
  };
  var META_PRODUCT_PATHS = [
    '/products/haro-clear-meta',
    '/products/meta-haro-clear-starter-kit-90-day-eye-health-supply',
    '/products/meta-haro-clear-refill-pouch-45-day-supply-eye-health-supplement-90-capsules',
    '/products/haro-clear-refill-pouch-90-day-supply-eye-health-supplement-180-capsules-meta'
  ];

  function getCookie(name) {
    var prefix = name + '=';
    var parts = document.cookie ? document.cookie.split(';') : [];
    for (var i = 0; i < parts.length; i += 1) {
      var part = parts[i].trim();
      if (part.indexOf(prefix) === 0) return decodeURIComponent(part.slice(prefix.length));
    }
    return '';
  }

  function setCookie(name, value) {
    document.cookie = name + '=' + encodeURIComponent(value) + '; path=/; max-age=' + COOKIE_MAX_AGE + '; SameSite=Lax';
  }

  function setCohort(value) {
    try {
      localStorage.setItem(COHORT_KEY, value);
    } catch (error) {}
    setCookie(COHORT_KEY, value);
  }

  function getCohort() {
    try {
      var local = localStorage.getItem(COHORT_KEY);
      if (local) return local;
    } catch (error) {}
    return getCookie(COHORT_KEY);
  }

  function hasMetaLandingSignal() {
    try {
      var params = new URLSearchParams(window.location.search || '');
      var forced = (params.get('haro_cohort') || '').toLowerCase();
      if (forced === META_VALUE) return true;

      var utmSource = (params.get('utm_source') || '').toLowerCase();
      if (META_SOURCES.indexOf(utmSource) >= 0) return true;

      if ((params.get('fbclid') || '').trim()) return true;
    } catch (error) {}
    return false;
  }

  function hasGoogleMerchantSignal() {
    try {
      var params = new URLSearchParams(window.location.search || '');
      var utmSource = (params.get('utm_source') || '').toLowerCase();
      var utmMedium = (params.get('utm_medium') || '').toLowerCase();
      var utmCampaign = (params.get('utm_campaign') || '').toLowerCase();
      var utmContent = (params.get('utm_content') || '').toLowerCase();

      if (utmSource === 'google') return true;
      if (utmMedium === 'product_sync') return true;
      if (utmCampaign.indexOf('sag_') === 0) return true;
      if (utmContent.indexOf('sag_') === 0) return true;
    } catch (error) {}
    return false;
  }

  function isMetaProductPath(pathname) {
    return META_PRODUCT_PATHS.indexOf(pathname) >= 0;
  }

  function mapToMetaPath(pathname) {
    return PRODUCT_PATH_MAP[pathname] || '';
  }

  function redirectIfNeeded() {
    if (isGoogleMerchantLanding) return;

    var cohort = getCohort();
    if (cohort !== META_VALUE) return;

    var targetPath = mapToMetaPath(window.location.pathname);
    if (!targetPath || targetPath === window.location.pathname) return;

    var destination = targetPath + (window.location.search || '') + (window.location.hash || '');
    window.location.replace(destination);
  }

  function rewriteProductLinksForMeta() {
    if (isGoogleMerchantLanding) return;
    if (getCohort() !== META_VALUE) return;

    document.querySelectorAll('a[href]').forEach(function (anchor) {
      var href = anchor.getAttribute('href') || '';
      if (!href) return;

      var parsed;
      try {
        parsed = new URL(href, window.location.origin);
      } catch (error) {
        return;
      }

      if (parsed.origin !== window.location.origin) return;
      if (parsed.pathname.indexOf('/products/') !== 0) return;

      var base = parsed.pathname;
      var suffix = (parsed.search || '') + (parsed.hash || '');
      var mapped = mapToMetaPath(base);
      if (mapped && mapped !== base) {
        anchor.setAttribute('href', mapped + suffix);
      }
    });
  }

  var isGoogleMerchantLanding = hasGoogleMerchantSignal();

  if (!isGoogleMerchantLanding && (hasMetaLandingSignal() || isMetaProductPath(window.location.pathname))) {
    setCohort(META_VALUE);
  }

  window.HARO_PRICE_COHORT = isGoogleMerchantLanding ? '' : (getCohort() || '');
  redirectIfNeeded();
  document.addEventListener('DOMContentLoaded', rewriteProductLinksForMeta);
  window.addEventListener('pageshow', rewriteProductLinksForMeta);
})();
